import type { components } from '@front/generated/apiClient';
import { ImmutableEntity } from '@front/repository/Api/converter/common';
import type { ImportTaskWithRelations } from '@front/repository/Api/ImportTask/interface';
import { DomainV2 } from 'troppus-common/domain';

import ImportTask = DomainV2.Import.ImportTask;

type Api = components['schemas']['ImportTask'];
type ApiWithRelations = components['schemas']['ImportTask.WithRelations'];

export const fromApi = (api: Api): ImportTask => {
  return ImportTask.Construct({
    ...ImmutableEntity.fromApi(api),
    id: api.id,
    projectId: api.projectId,
    source: api.source,
    importTableDefinitionRevisionId: api.importTableDefinitionRevisionId,
    fileId: api.fileId,
    status: api.status,
    resultType: api.resultType,
    resultJson: api.resultJson,
    progressJson: api.progressJson,
    startedAt: api.startedAt,
    finishedAt: api.finishedAt,
  });
};

export const fromApiWithRelations = (api: ApiWithRelations): ImportTaskWithRelations => {
  return {
    ...fromApi(api),
    importTableDefinitionRevision: api.importTableDefinitionRevision
      ? {
          revisionNumber: api.importTableDefinitionRevision.revisionNumber,
          compatibilityType: api.importTableDefinitionRevision.compatibilityType,
          changeSummary: api.importTableDefinitionRevision.changeSummary,
        }
      : undefined,
  };
};
